import styled from "styled-components";
export const Icon = styled.span `
  display: inline-flex;
  transition: .1s ease-in-out;

  & > svg {
    pointer-events: none;
  }
`;
